/**
 * @Author: Li, Yu Jia
 * @Date: 2019-12-13 08:40:15
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2021-06-25 13:55:13
 * @Usage: imprintarea.logics.fun
 */

import {
  IMPRINT_AREA_NONE,
  ProcessTypes,
  colorSpace,
  colorType,
  imprintOptionType,
  stockArtColorType,
  userImageType,
} from '../utils/constants';
import {
  MATCHTRIMCODE,
  PMS_COLOR_EXCEPTION_MESSAGE,
  PMS_ENTRY_INVALID_MESSAGE,
  TOO_MANY_COLORS_CHOSEN_MESSAGE,
  TYPESETTING_LOCATION_NA,
  typeSettingLocationType,
} from './constants';
import { changeArtColor as changeArtColorAction, deleteImage, setImageUI } from './../canvas/actions';
import { changeNonDigitalColor, changeTextLineColor, initNonDigitalText } from './../text/actions';
import { changePreviewDefaultImprintColor, updateFullPreview } from '../preview/logics';
import { configuratorAction, studioItemType } from '../main/constants';
import {
  getAdditionlEachImprintCharge,
  getAddtionalImprintSpecialCharge,
  getAllAppliedImprintAreaKeys,
  getAllNextGenUIImprintAreaDict,
  getAllNextGenUIImprintAreaKeys,
  getCurrentSelectedCombination,
  getImprintAreaCustomized,
  getImprintColors,
  getImprintOptionMaxColorCount,
  getImprintOptionOfferLogo,
  getImprintOptionType,
  getIsHideOptionTypeSelectionForLaserGrow,
  getSelectedImprintColors,
  getSelectedRuleInGroup,
  getTempSelectedImprintAreaKeys,
} from './selectors';
import {
  getConfiguratorAction,
  imprintOptionUISetAsync,
  userImagePrepare,
  validateCurrentImprintAreaInternalInvalid,
} from '../main/logics';
import {
  getCurrentDebossCheck,
  getCurrentHotStampedCheck,
  getCurrentImprintAreaCode,
  getCurrentImprintAreaKey,
  getInitializedImprintAreaKeys,
  getSaveProject,
  getSpecialSpellingWords,
  getStudioItemType,
} from '../main/selectors';
import { hideWaitingCover, setCurrentImprintAreaKey, setGuideMode, showMessageBox } from '../main/actions';
import {
  imprintAreasCombinedInit,
  imprintAreasCombinedSelect,
  imprintAreasInit,
  imprintColorInitialize,
  imprintColorUpdate,
  imprintOptionTypeSelect,
  logoLayoutInit,
  logoLayoutSelect,
  logoLayoutSelectDefault,
  textLayoutInit,
  textLayoutSelect,
  textLayoutSelectDefault,
} from './actions';
import { setAlertInfo, setCurrentBomOption, showImprintRuleChangeConfirmModal } from '../nextgen/actions';

import { ADDITIONAL_PRINT_SURFACE_CHARGE } from '../nextgen/constants';
import { BASE_API } from '../utils/base';
import axios from 'axios';
import { changeColor } from './../text/logics';
import { checkIsLaserProduct } from '../utils/processTypeUtil';
import { formatCharge } from '../utils/formatter';
import { getPreviewColor } from '../preview/selectors';
import { getTextLine } from '../text/selectors';
import { nextGenChangeSideBarKeyToGetStarted } from '../nextgen/logics';
import { rgbToCMYK } from '../utils';
import { setUserImageClone } from '../userimage/actions';

export const formatsCompare = (format0, format1) => {
  if (!(format0 instanceof Array)) {
    throw new Error('format0 is not Array!');
  }
  if (!(format1 instanceof Array)) {
    throw new Error('format1 is not Array!');
  }

  if (format0.length !== format1.length) return false;
  const format0Sort = format0.sort();
  const format1Sort = format1.sort();
  for (let i = 0, l = format0Sort.length; i < l; i++) {
    if (format0Sort[i] instanceof Array && format1Sort[i] instanceof Array) {
      if (!formatsCompare(format0Sort[i], format1Sort[i])) return false;
    } else if (format0Sort[i] !== format1Sort[i]) {
      return false;
    }
  }
  return true;
};

export const imprintAreasInitAsync = (res) => (dispatch) => {
  if (res.imprintFormats !== undefined) {
    dispatch(imprintAreasInit({ formats: res.imprintFormats }));
  }
  if (res.imprintGroups !== undefined) {
    dispatch(imprintAreasCombinedInit({ groups: res.imprintGroups }));

    /**
     * if there is only imprint area option for each imprint group
     * NoImprint selected by default from shoppingCart
     * Keep one work flow with New Action
     */
    //dispatch(noneImprintAreasSelectForEditActionAsync());
  }
};

/**
 * if there is only imprint area option for each imprint group
 * NoImprint selected by default from shoppingCart
 * Keep one work flow with New Action
 */
const noneImprintAreasSelectForEditActionAsync = () => (dispatch, getState) => {
  const state = getState();
  const action = getConfiguratorAction(state.parameters.status);
  if (action !== configuratorAction.new) {
    const imprintAreasCombinedDict = state.imprintAreasCombinedDict;
    if (Object.keys(imprintAreasCombinedDict).length > 1) {
      const noneImprintAreaCheck = (combined) =>
        !(combined.formats && combined.formats.every((x) => x === IMPRINT_AREA_NONE));

      imprintAreasCombinedDict &&
        Object.keys(imprintAreasCombinedDict)
          .filter(
            (gkey) =>
              imprintAreasCombinedDict[gkey].combinations.filter((com) => noneImprintAreaCheck(com)).length === 1 &&
              !imprintAreasCombinedDict[gkey].combinations.find((x) => x.selected)
          )
          .forEach((gkey) => dispatch(imprintAreaSelectedAsync([IMPRINT_AREA_NONE], gkey)));
    }
  }
};

export const textLayoutInitAsync = (locations) => (dispatch) => {
  dispatch(textLayoutInit(locations));
};
export const logoLayoutInitAsync = (locations) => (dispatch) => {
  dispatch(logoLayoutInit(locations));
};

export const nextGenImprintAreaSelectedAsync = () => (dispatch, getSate) => {
  const state = getSate();
  const allSelectedKeys = getAllNextGenUIImprintAreaKeys(state);
  const currentStudioItemType = getStudioItemType(state);

  switch (currentStudioItemType) {
    case studioItemType.digital:
    case studioItemType.screenPrintedDigital: {
      dispatch(imprintOptionTypeInitForDigitalAsync(allSelectedKeys));
      dispatch(textLayoutSelectDefault(allSelectedKeys));
      dispatch(logoLayoutSelectDefault(allSelectedKeys));
      //dispatch(nextgenUiSelectImprintArea(allSelectedKeys[0], ''));
      break;
    }
    case studioItemType.nonDigital: {
      allSelectedKeys.length > 0 &&
        (() => {
          dispatch(setCurrentImprintAreaKey(allSelectedKeys[0]));
          dispatch(imprintOptionTypeInitAsync(allSelectedKeys));
        })();
      break;
    }
  }
  dispatch(userImagePrepare());
  dispatch(changePreviewDefaultImprintColor({ imprintAreaKeys: allSelectedKeys }));
};

export const nextgenUiFinalSelectImprintAreas = () => (dispatch, getState) => {
  const state = getState();
  const allAppliedKeys = getAllAppliedImprintAreaKeys(state);
  const combinedDict = state.imprintAreasCombinedDict;

  Object.keys(combinedDict).forEach((groupKey) => {
    const selectedCombination = combinedDict[groupKey].combinations.find((x) => x.selected);
    if (selectedCombination) {
      const selectedImprintAreaKeys = selectedCombination.formats.filter((x) => allAppliedKeys.indexOf(x) > -1);
      dispatch(
        imprintAreasCombinedSelect({
          formatSelected: selectedImprintAreaKeys,
          groupKey,
        })
      );
    }
  });
};
const alertAdditionalImprintChargeWhenSwitchImprintArea = (selectedImprintAreaKey) => (dispatch, getState) => {
  const state = getState();
  const isCustomized = getImprintAreaCustomized(state, selectedImprintAreaKey);
  const allAppliedKeys = getAllAppliedImprintAreaKeys(state);
  if (!isCustomized) {
    let totalCharge = getAddtionalImprintSpecialCharge(state, selectedImprintAreaKey);
    if (allAppliedKeys.length > 0) {
      const additionalImprintCharge = getAdditionlEachImprintCharge(state);
      totalCharge += additionalImprintCharge;
      dispatch(
        setAlertInfo({
          show: true,
          variant: 'info',
          showCloseBtn: true,
          message: ADDITIONAL_PRINT_SURFACE_CHARGE.replace('{charge}', formatCharge(totalCharge)),
        })
      );
    }
  }
};
export const nextgenUiSelectImprintArea =
  (selectedImprintAreaKey, isConfirm = false) =>
  (dispatch, getState) => {
    const state = getState();

    const imprintAreasDict = getAllNextGenUIImprintAreaDict(state);
    const groupKey = imprintAreasDict[selectedImprintAreaKey].group;

    const currentImprintAreaKey = getCurrentImprintAreaKey(state);
    const currentCombination = getCurrentSelectedCombination(state, groupKey);
    if (selectedImprintAreaKey === currentImprintAreaKey && currentCombination) {
      return;
    }

    if (!currentCombination) {
      dispatch(
        imprintAreasCombinedSelect({
          formatSelected: [selectedImprintAreaKey],
          groupKey,
        })
      );
    } else {
      const combinationImprintAreas = currentCombination.formats;
      if (combinationImprintAreas.indexOf(selectedImprintAreaKey) > -1) {
        if (!dispatch(validateCurrentImprintAreaInternalInvalid())) {
          return;
        }
      } else {
        const currentSelectedRule = getSelectedRuleInGroup(state, groupKey);
        const selectedRule = imprintAreasDict[selectedImprintAreaKey].rule;
        if (
          !selectedRule ||
          !currentSelectedRule?.ruleName ||
          (currentSelectedRule && currentSelectedRule.ruleName && selectedRule === currentSelectedRule.ruleName)
        ) {
          const selectedImprintAreas = [...combinationImprintAreas, selectedImprintAreaKey];
          if (
            !dispatch(
              validateElementsAndThenSelectCombination({
                formatSelected: selectedImprintAreas,
                groupKey,
                currentImprintAreaKey,
              })
            )
          ) {
            return;
          }
        } else {
          if (!isConfirm) {
            const allAppliedKeys = getAllAppliedImprintAreaKeys(state);
            // -- If some areas of current selected rule are customized, popup confirm modal to let user confirm
            if (allAppliedKeys.some((x) => currentSelectedRule.imprintAreas.indexOf(x) > -1)) {
              let ruleConfirmMoal = {
                imprintGroup: groupKey,
                currentRule: currentSelectedRule.ruleName,
                selectImprintArea: selectedImprintAreaKey,
              };

              dispatch(showImprintRuleChangeConfirmModal(ruleConfirmMoal));
              return;
            }
          }

          let newSelectedAreas = combinationImprintAreas;

          // -- new selected areas exclude imprint areas of current selected rule
          if (currentSelectedRule && currentSelectedRule.imprintAreas) {
            newSelectedAreas = combinationImprintAreas.filter(
              (x) => currentSelectedRule.imprintAreas.indexOf(x) === -1
            );
          }

          newSelectedAreas = [...newSelectedAreas, selectedImprintAreaKey];
          if (
            !dispatch(
              validateElementsAndThenSelectCombination({
                formatSelected: newSelectedAreas,
                groupKey,
                currentImprintAreaKey,
              })
            )
          ) {
            return;
          }
        }
      }
    }

    dispatch(setCurrentImprintAreaKey(selectedImprintAreaKey));
    dispatch(userImagePrepare());
    nextGenChangeSideBarKeyToGetStarted({ dispatch, canvasKey: selectedImprintAreaKey, studioItemType });
    dispatch(changeDebossColor(selectedImprintAreaKey));
    dispatch(updateFullPreview());
    dispatch(alertAdditionalImprintChargeWhenSwitchImprintArea(selectedImprintAreaKey));
    dispatch(hideWaitingCover());
  };

const validateElementsAndThenSelectCombination =
  ({ formatSelected, groupKey, currentImprintAreaKey }) =>
  (dispatch, getState) => {
    const isCurrentImprintAreaKeyInclude = formatSelected.indexOf(currentImprintAreaKey) > -1;
    if (isCurrentImprintAreaKeyInclude && !dispatch(validateCurrentImprintAreaInternalInvalid())) {
      return false;
    }

    dispatch(
      imprintAreasCombinedSelect({
        formatSelected,
        groupKey,
      })
    );

    return true;
  };

export const imprintAreaSelectedAsync = (formatSelected, groupKey) => (dispatch, getSate) => {
  dispatch(
    imprintAreasCombinedSelect({
      formatSelected,
      groupKey,
    })
  );
  const state = getSate();
  const allSelectedKeys = getTempSelectedImprintAreaKeys(state);
  const currentStudioItemType = getStudioItemType(state);
  switch (currentStudioItemType) {
    case studioItemType.digital:
    case studioItemType.screenPrintedDigital: {
      dispatch(imprintOptionTypeInitForDigitalAsync(allSelectedKeys));
      dispatch(textLayoutSelectDefault(allSelectedKeys));
      dispatch(logoLayoutSelectDefault(allSelectedKeys));
      break;
    }
    case studioItemType.nonDigital: {
      allSelectedKeys.length > 0 &&
        (() => {
          dispatch(setCurrentImprintAreaKey(allSelectedKeys[0]));
          dispatch(imprintOptionTypeInitAsync(allSelectedKeys));
        })();
      break;
    }
  }
  dispatch(userImagePrepare());
};

export const imprintAreasCombinedSelectAsync = (formatSelected, groupKey) => (dispatch) => {
  dispatch(
    imprintAreasCombinedSelect({
      formatSelected,
      groupKey,
    })
  );
};

export const imprintAreaSelectedAutomatic = () => (dispatch, getState) => {
  const state = getState();
  const imprintAreasCombinedDict = state.imprintAreasCombinedDict;
  const noneImprintAreaCheck = (combined) =>
    !(combined.formats && combined.formats.every((x) => x === IMPRINT_AREA_NONE));
  imprintAreasCombinedDict &&
    Object.keys(imprintAreasCombinedDict)
      .filter(
        (gkey) =>
          imprintAreasCombinedDict[gkey].combinations.filter((com) => noneImprintAreaCheck(com)).length === 1 &&
          !imprintAreasCombinedDict[gkey].combinations.find((x) => x.selected)
      )
      .forEach((gkey) =>
        imprintAreasCombinedDict[gkey].combinations
          .filter((com) => noneImprintAreaCheck(com))
          .forEach((com) => {
            dispatch(imprintAreaSelectedAsync(com.formats, gkey));
          })
      );
};

export const getAllSelectedImprintAreaKeysFromImprintAreasCombinedDict = (imprintAreasCombinedDict) => {
  let chosen = [];
  let allGroupKeys = Object.keys(imprintAreasCombinedDict);
  if (allGroupKeys && allGroupKeys.length > 0) {
    allGroupKeys.map((group, _) => {
      const groups = imprintAreasCombinedDict[group];
      groups &&
        groups.combinations &&
        groups.combinations.map((com, _) => {
          if (com.selected) {
            chosen = chosen.concat(com.formats);
          }
          return true;
        });
      return true;
    });
  }
  return chosen;
};

export const setImprintOptionTypeSelectedAsync = (formatkey, typeSelected) => (dispatch, getState) => {
  dispatch(imprintOptionTypeSelect({ formatkey, typeSelected }));
};

export const logoLayoutSelectAsync = (formatkey, locationSelected) => (dispatch, getState) => {
  dispatch(logoLayoutSelect({ formatkey, locationSelected }));
};
export const textLayoutSelectAsync = (formatkey, locationSelected) => (dispatch, getState) => {
  dispatch(textLayoutSelect({ formatkey, locationSelected }));
};

/**
 * make the first location option as selected
 * @param {key} key
 * @param {locationType} locationType
 */
export const defaultTypeSettingSelectedAsync = (key, locationType) => (dispatch, getState) => {
  const state = getState();
  const actionDispatch = (locationdict, action) => {
    if (locationdict[key] && locationdict[key].length > 0 && locationdict[key].every((x) => !x.selected)) {
      const locationListSorted = locationListSort(locationdict[key]);
      dispatch(action(key, { key: locationListSorted[0].locationCode }));
    }
  };
  if (locationType === typeSettingLocationType.Logo) {
    actionDispatch(state.logoLocationDict, logoLayoutSelectAsync);
  } else {
    actionDispatch(state.imprintLocationDict, textLayoutSelectAsync);
  }
};

/**
 * clear location option selected
 * @param {key} key
 * @param {locationType} locationType
 */
export const clearUpTypeSettingSelectedAsync = (key, locationType) => (dispatch, getState) => {
  const state = getState();
  const actionDispatch = (locationdict, action) => {
    if (locationdict[key] && locationdict[key].length > 0) {
      dispatch(action(key, { key: TYPESETTING_LOCATION_NA }));
    }
  };
  if (locationType === typeSettingLocationType.Logo) {
    actionDispatch(state.logoLocationDict, logoLayoutSelectAsync);
  } else {
    actionDispatch(state.imprintLocationDict, textLayoutSelectAsync);
  }
};

export const locationListSort = (locationList) => {
  return [...locationList.filter((x) => x.isStandard), ...locationList.filter((x) => !x.isStandard)];
};
export const layoutFormat = (location) => ({
  key: location.locationCode,
  description: location.locationDescription,
  selected: location.selected,
  isStandard: location.isStandard,
});

export const imprintColorInitAsync = (colors) => (dispatch) => {
  const color = {};
  Object.keys(colors).forEach((key) => {
    color[key] = colors[key].map((color) =>
      Object.assign({}, color, {
        cmyk: color.colorType === colorType.Traditional && color.colorReference ? rgbToCMYK(color.colorReference) : '',
      })
    );
  });
  dispatch(imprintColorInitialize(color));
};

/**
 * imprintColorFormat
 * @param {Array} colors
 * @param {Object} bom
 */
export const imprintColorFormat = (colors, bom) => {
  let trimColors = [];
  if (colors.length > 0 && bom && bom.hasTrimColor) {
    trimColors = colors.filter(
      (color) =>
        color.colorType !== colorType.Pms &&
        MATCHTRIMCODE.filter((code) => code.toLowerCase().indexOf(color.colorId.toLowerCase()) > -1).length > 0
    );
    if (trimColors.length > 0) {
      trimColors = trimColors.map((color) =>
        Object.assign({}, color, { colorReference: bom.colorReference, cmyk: rgbToCMYK(bom.colorReference) })
      );
    }
  }

  const all = [
    ...trimColors,
    ...colors.filter(
      (x) =>
        x.colorType !== colorType.Pms &&
        MATCHTRIMCODE.filter((code) => code.toLowerCase().indexOf(x.colorId.toLowerCase()) > -1).length === 0
    ),
    ...colors.filter((x) => x.colorType === colorType.Pms),
  ];

  return all
    .map((_color) =>
      Object.assign({}, _color, {
        colorReference: _color.colorReference ? _color.colorReference.replace('#', '') : '',
      })
    )
    .filter((x) => x);
};

export const checkImprintOptionOfferLogo = (state, key) => {
  const logoLocationDict = state.logoLocationDict;
  const imprintAreaDict = state.imprintAreaDict;
  return (
    (logoLocationDict[key] && logoLocationDict[key].length > 0) ||
    (imprintAreaDict[key] && imprintAreaDict[key].logoOnly)
  );
};

export const getIsLaserGrowType = (state, key) => {
  const format = state.imprintAreaDict[key];
  const offerLogo = checkImprintOptionOfferLogo(state, key);
  const laserGrowType =
    offerLogo &&
    format &&
    (checkIsLaserProduct(format.processType) || format.processType === ProcessTypes.DigitalIlluminatedLaser);
  return laserGrowType;
};

/**
 * Init LogoOnly Swatch in NonDigital Studio, and make it selected by default, even if it don't show in page
 * Because there is only one LogoLayout (LOGO hard code from api, TypeSettingLocation.Type="L") for Digital Item
 * @param {Array} allSelectedKeys
 */
export const imprintOptionTypeInitAsync = (allSelectedKeys) => (dispatch, getState) => {
  const state = getState();
  const imprintAreaDict = state.imprintAreaDict;
  const imprintOptionTypeDict = Object.assign({}, state.imprintOptionTypeDict);

  allSelectedKeys.forEach((formatkey) => {
    //NonDigital products
    //Only executed once when Initializing
    if (!imprintOptionTypeDict[formatkey].some((x) => x.selected)) {
      const format = imprintAreaDict[formatkey];
      if (format) {
        if (!format.logoOnly) {
          const isHideOptionTypeSelectionForLaserGrow = getIsHideOptionTypeSelectionForLaserGrow(state, formatkey);
          if (isHideOptionTypeSelectionForLaserGrow) {
            /*
             * if isHideOptionTypeSelectionForLaserGrow is true
             * Add ImprintOptionType.LogoOnly into LogoLayout list
             * Don't show ImprintOptionType section
             */
            dispatch(
              setImprintOptionTypeSelectedAsync(
                formatkey,
                imprintOptionTypeDict[formatkey].filter((x) => x.key === imprintOptionType.TextLogo)[0]
              )
            );
            dispatch(defaultTypeSettingSelectedAsync(formatkey, typeSettingLocationType.Text));
            dispatch(defaultTypeSettingSelectedAsync(formatkey, typeSettingLocationType.Logo));
          }
        }
        //ImprintOptionType is be Selected for TextOnly or LogoOnly by default
        if (imprintOptionTypeDict[formatkey].length === 1) {
          dispatch(setImprintOptionTypeSelectedAsync(formatkey, imprintOptionTypeDict[formatkey][0]));
          dispatch(defaultTypeSettingSelectedAsync(formatkey, typeSettingLocationType.Text));
          dispatch(defaultTypeSettingSelectedAsync(formatkey, typeSettingLocationType.Logo));
        }
      }
    }
  });
};

/**
 * Init TextOnly, LogoOnly, TextAndLogo and NoImprint OptionType Swatch in (ScreenPrint)Digital Studio
 * for Popup 1b in old studio
 * @param {Array} allSelectedKeys
 */
export const imprintOptionTypeInitForDigitalAsync = (allSelectedKeys) => (dispatch, getState) => {
  const state = getState();
  const imprintOptionTypeDict = Object.assign({}, state.imprintOptionTypeDict);
  allSelectedKeys.forEach((formatkey) => {
    //Digital products and screenPrintedDigital products
    //Only executed once and only have logoOnly and set the select value of logoOnly to true
    if (!imprintOptionTypeDict[formatkey].some((x) => x.selected)) {
      dispatch(setImprintOptionTypeSelectedAsync(formatkey, imprintOptionTypeDict[formatkey][0]));
    }
  });
};

const changeArtColor =
  ({ canvasKey, guid, colors, isColorized }) =>
  (dispatch, getState) => {
    const state = getState();
    const isHotStamped = getCurrentHotStampedCheck(state);
    dispatch(changeArtColorAction({ canvasKey, guid, colors, isHotStamped, isColorized }));
  };
//private logics --- end

/*
 * record TextColor for imprintOption in Popup 1b
 * we can use it in step2 directly to save into TextElement.Colors
 */
export const recordTextColorAsync =
  ({ formatkey, color }) =>
  (dispatch, getState) => {
    const state = getState();
    const currentStudioItemType = getStudioItemType(state);
    const imprintAreaCode = getCurrentImprintAreaCode(state);
    let newColor = color;
    if (newColor !== null) {
      newColor = Object.assign({}, newColor, {
        cmyk: color.colorType === colorType.Traditional && color.colorReference ? rgbToCMYK(color.colorReference) : '',
      });
    }

    dispatch(
      imprintOptionUISetAsync([formatkey], () => ({
        textColor: newColor,
      }))
    );
    if (newColor !== null && currentStudioItemType === studioItemType.nonDigital) {
      dispatch(changeTextLineColor({ imprintAreaCode, selectedColor: newColor }));
    }
  };

let cancelTokenSourceForPmsColor = null;
export const getPmsColorReferenceAsync = (pmscode, callback) => {
  const url = `/api/v1/pms?pmsCode=${pmscode}`;
  const headers = {
    APL_Token: sessionStorage.getItem('apl_token') === null ? '' : sessionStorage.getItem('apl_token'),
    'Cache-Control': 'no-cache',
  };
  if (cancelTokenSourceForPmsColor) {
    cancelTokenSourceForPmsColor.cancel();
  }
  cancelTokenSourceForPmsColor = axios.CancelToken.source();
  return axios({
    method: 'get',
    url: url.startsWith('https://') || url.startsWith('http://') ? url : BASE_API().trimRight('/') + url,
    headers: headers,
    cancelToken: cancelTokenSourceForPmsColor.token,
  })
    .then((response) => {
      sessionStorage.setItem('apl_token', response.headers['apl_token']);
      sessionStorage.setItem('apl_token_timeout', response.headers['apl_token_timeout']);
      return response;
    })
    .then((response) => {
      callback && callback(response.data);
      cancelTokenSourceForPmsColor = null;
    })
    .catch((_) => {});
};

/**
 * change TextColor for NonDigital Studio
 * @param {*} formatkey
 * @param {*} colors
 */
export const changeTextColorAsync =
  ({ formatkey, color }, callback) =>
  (dispatch, getState) => {
    const state = getState();

    //record TextColor in state.ui.imprintOption.textColor
    dispatch(recordTextColorAsync({ formatkey, color }));
    // change text color
    dispatch(updateTextAndOutsideImageColorAsync({ formatkey, color }));

    //image color change as the same as text color if single imprint color
    const maxColorCount = getImprintOptionMaxColorCount(state);
    if (maxColorCount === 1) {
      dispatch(() => {
        if (state.imageDict && state.imageDict[formatkey]) {
          //excluding outside UserImage
          const images = state.imageDict[formatkey].filter((x) => !outsideUserImageMatch(x.data));
          if (images) {
            images.forEach((img) => {
              dispatch(
                setImageUI({
                  type: 'keep_img_color',
                  canvasKey: formatkey,
                  guid: img.ui.guid,
                  data: { colors: [color] },
                })
              );
            });
          }
        }
      });
    }

    callback && callback();
  };

/**
 * change LogoColor for NonDigital Studio
 * @param {*} formatkey
 * @param {*} colors
 */
export const changeLogoColorAsync =
  ({ formatkey, guid, colors }, callback) =>
  (dispatch, getState) => {
    const state = getState();
    const userimg = state.imageDict[formatkey].find((x) => x.ui.guid === guid);
    const isColorized =
      userimg &&
      userimg.data &&
      checkShowImageColorized({
        studioType: getStudioItemType(state),
        userImage: userimg.data,
        imprintArea: state.imprintAreaDict[formatkey],
      });
    const currentStudioItemType = getStudioItemType(state);
    dispatch(changeArtColor({ canvasKey: formatkey, guid, colors, isColorized }));

    const maxColorCount = getImprintOptionMaxColorCount(state);
    if (currentStudioItemType !== studioItemType.digital) {
      if (maxColorCount === 1) {
        if (colors && colors.length > 0) {
          const textColor = colors[0];
          // change text color
          dispatch(changeTextColorAsync({ formatkey, color: textColor }));
        }
      } else {
        if (userimg && userimg.data && outsideUserImageMatch(userimg.data)) {
          if (colors && colors.length > 0) {
            //record outside image colors[0] in state.ui.imprintOption.textColor
            dispatch(recordTextColorAsync({ formatkey, color: colors[0] }));
          }
        }
      }
    }

    callback && callback();
  };

const updateTextAndOutsideImageColorAsync =
  ({ formatkey, color }) =>
  (dispatch, getState) => {
    const state = getState();
    const currentStudioItemType = getStudioItemType(state);
    const textList = state.textDict[formatkey];
    if (textList !== undefined && textList !== null) {
      let increment = {};
      increment.data = {
        color: {
          cmyk: '',
          colorReference: color.colorReference,
          colorType: color.colorType,
          colorId: color.colorId,
          colorDescription: color.colorDescription,
        },
      };
      if (textList.length > 0) {
        if (currentStudioItemType === studioItemType.nonDigital) {
          const guids = textList.map((element) => element.ui.guid);
          dispatch(changeNonDigitalColor({ formatkey, increment, guids }));
        } else if (currentStudioItemType === studioItemType.screenPrintedDigital && color.colorReference) {
          textList.forEach((element) => {
            dispatch(
              changeColor(
                element.ui.guid,
                color.cmyk,
                color.colorId,
                color.colorReference,
                color.colorType,
                color.colorDescription
              )
            );
          });
        }
      }
    }

    /**
     * change outside userimage colors
     * @param {*} predicateMatch
     */
    const userImageColorChange = (predicateMatch) => {
      if (state.imageDict && state.imageDict[formatkey]) {
        const userimg = state.imageDict[formatkey].find(predicateMatch);

        if (userimg) {
          const isColorized =
            userimg.data &&
            checkShowImageColorized({
              studioType: getStudioItemType(state),
              userImage: userimg.data,
              imprintArea: state.imprintAreaDict[formatkey],
            });
          dispatch(
            changeArtColor({
              canvasKey: formatkey,
              guid: userimg.ui.guid,
              colors: [color],
              isColorized,
            })
          );
        }
      }
    };

    //outsideSlogan
    dispatch(() => {
      userImageColorChange((x) => x.data.type === userImageType.Slogan && x.data.isOutside);
    });

    //verse
    dispatch(() => {
      userImageColorChange((x) => x.data.type === userImageType.Verse);
    });

    //sentiment
    dispatch(() => {
      userImageColorChange((x) => x.data.type === userImageType.Sentiment);
    });
  };

/**
 * ImprintColor is be chosen by default
 * update TextColor, outside slogan, verse, sentiment in the meanwhile
 * @param {*} formatkey
 * @param {*} colorSelected
 */
export const defaultImprintColorAsync = (formatkey) => (dispatch, getState) => {
  const state = getState();

  const imprintColors = getImprintColors(state, formatkey);
  if (imprintColors.length === 1) {
    dispatch(changeTextColorAsync({ formatkey, color: imprintColors[0] }));
  }
};

export const changeCurrentBomOption =
  (bomOption, formateKey = null) =>
  (dispatch, getState) => {
    dispatch(setCurrentBomOption(bomOption));

    const productColor = bomOption.colorReference.replace('#', '');

    dispatch(changeDebossColor(formateKey, productColor));
  };

export const changeDebossColor =
  (formatekey = null, currentColor = null) =>
  (dispatch, getState) => {
    const state = getState();
    const isDeboss = getCurrentDebossCheck(state);

    if (isDeboss) {
      let productColor = currentColor;
      if (!currentColor) {
        const previewColor = getPreviewColor(state);
        productColor = previewColor.replace('#', '');
      }

      let currentImprintAreaKey;
      if (formatekey) {
        currentImprintAreaKey = formatekey;
      } else {
        currentImprintAreaKey = getCurrentImprintAreaKey(state);
      }

      const imprintAreaCode = state.imprintAreaDict[currentImprintAreaKey]?.imprintAreaCode;

      if (imprintAreaCode) {
        const debossColorReference = calculateDebossColor(productColor);

        const debossColor = {
          cmyk: rgbToCMYK(debossColorReference),
          colorId: 'DEB',
          colorReference: debossColorReference,
          colorDescription: 'Debossed',
          colorType: 1,
        };

        dispatch(imprintColorUpdate({ imprintAreaCode, imprintColors: [debossColor] }));

        dispatch(changeTextColorAsync({ formatkey: currentImprintAreaKey, color: debossColor }));
      }
    }
  };

export const calculateDebossColor = (hexColor) => {
  if (!hexColor) return '';
  let r = parseInt(hexColor.slice(0, 2), 16);
  let g = parseInt(hexColor.slice(2, 4), 16);
  let b = parseInt(hexColor.slice(4, 6), 16);
  const isDark = isDarkColor(r, g, b);

  const factor = 0.2;
  if (isDark) {
    r = Math.round(r + (255 - r) * factor);
    g = Math.round(g + (255 - g) * factor);
    b = Math.round(b + (255 - b) * factor);
  } else {
    r = Math.round(r * (1 - factor));
    g = Math.round(g * (1 - factor));
    b = Math.round(b * (1 - factor));
  }

  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));

  return [r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('');
};

function isDarkColor(r, g, b) {
  const brightness = r * 0.299 + g * 0.587 + b * 0.114;
  return brightness < 100;
}

export const initNonDigitalTextActionForWishList = (formatkey) => (dispatch, getState) => {
  const state = getState();
  const saveProjectInfo = getSaveProject(state);
  const currentStudioItemType = getStudioItemType(state);
  const currentImprintOptionType = getImprintOptionType(state, formatkey);
  const initializedImprintAreaKeys = getInitializedImprintAreaKeys(state);

  if (
    saveProjectInfo &&
    saveProjectInfo.isWishlistItem &&
    currentStudioItemType === studioItemType.nonDigital &&
    (currentImprintOptionType === imprintOptionType.TextOnly ||
      currentImprintOptionType === imprintOptionType.TextLogo) &&
    !(state.textDict && state.textDict[formatkey] && state.textDict[formatkey].length > 0) &&
    initializedImprintAreaKeys.indexOf(formatkey) > -1
  ) {
    const textLines = getTextLine(formatkey)(state);
    textLines && dispatch(initNonDigitalText(textLines));
  }
};

/**
 * if current imprint area has ImprintColor chosen and multiple imprint areas chosen,
 * and meanwhile other imprint areas have no imprintcolor except the first imprint area
 * we will apply the first imprintcolor of imprint area to others
 */
export const applyCurrentImprintColorToOtherOptionAsync = (color) => (dispatch, getState) => {
  const state = getState();
  const currentFormatKey = state.ui.currentImprintAreaKey;
  const allImprintOptionUI = state.ui.imprintOption;
  const allSelectedKeys = getTempSelectedImprintAreaKeys(state);
  if (color) {
    if (
      allSelectedKeys.length > 1 &&
      allSelectedKeys.indexOf(currentFormatKey) === 0 &&
      !allSelectedKeys
        .filter((key) => key !== currentFormatKey)
        .every((key) => {
          return allImprintOptionUI && allImprintOptionUI[key] && allImprintOptionUI[key].textColor;
        })
    ) {
      allSelectedKeys
        .filter((key) => key !== currentFormatKey)
        .forEach((key) => {
          if (getImprintColors(state, key).some((everyColor) => everyColor.colorId === color.colorId)) {
            dispatch(changeTextColorAsync({ formatkey: key, color }));
          }
        });
    }
  } else {
    if (
      allImprintOptionUI[currentFormatKey] &&
      allImprintOptionUI[currentFormatKey].textColor &&
      allSelectedKeys.length > 1 &&
      allSelectedKeys.indexOf(currentFormatKey) === 0 &&
      !allSelectedKeys
        .filter((key) => key !== currentFormatKey)
        .every((key) => {
          return allImprintOptionUI && allImprintOptionUI[key] && allImprintOptionUI[key].textColor;
        })
    ) {
      allSelectedKeys
        .filter((key) => key !== currentFormatKey)
        .forEach((key) => {
          dispatch(changeTextColorAsync({ formatkey: key, color: allImprintOptionUI[currentFormatKey].textColor }));
        });
    }
  }
};

/**
 * imprintLocation is be chosen for the first option by default
 * @param {*} formatkey
 */
export const defaultTextLayoutSelectedAsync = (formatkey) => (dispatch, getState) => {
  const state = getState();
  const imprintLocations = state.imprintLocationDict[formatkey];
  if (imprintLocations && imprintLocations.length === 1) {
    dispatch(
      textLayoutSelectAsync(formatkey, {
        key: imprintLocations[0].locationCode,
      })
    );
  }
};

/**
 * logoLocationDict is be chosen for the first option by default
 * @param {*} formatkey
 */
export const defaultlogoLayoutSelectedAsync = (formatkey) => (dispatch, getState) => {
  const state = getState();
  const logoLocations = state.logoLocationDict[formatkey];
  if (logoLocations && logoLocations.length === 1) {
    dispatch(
      logoLayoutSelectAsync(formatkey, {
        key: logoLocations[0].locationCode,
      })
    );
  }
};

/**
 * ImprintOptionType is be Selected for TextOnly or LogoOnly by default
 * @param {string} formatkey
 */
export const defaultImprintOptionTypeSelectedAsync = (formatkey) => (dispatch, getState) => {
  const state = getState();

  const offerLogo = getImprintOptionOfferLogo(state, formatkey);
  //textOnly
  if (!offerLogo) {
    dispatch(setImprintOptionTypeSelectedAsync(formatkey, { key: imprintOptionType.TextOnly }));
  } else {
    //logoOnly
    const imprintArae = state.imprintAreaDict[formatkey];
    if (imprintArae && imprintArae.logoOnly) {
      dispatch(setImprintOptionTypeSelectedAsync(formatkey, { key: imprintOptionType.LogoOnly }));
    }
  }
};
export const makeSelectionAutoAsync = (formatkey) => (dispatch) => {
  //ImprintOptionType default
  dispatch(defaultImprintOptionTypeSelectedAsync(formatkey));
  //text layout default
  dispatch(defaultTextLayoutSelectedAsync(formatkey));
  //logo layout default
  dispatch(defaultlogoLayoutSelectedAsync(formatkey));
  //for old WishList; if the textList is null, copy textLine to textList
  dispatch(initNonDigitalTextActionForWishList(formatkey));
  //imprint color default
  dispatch(defaultImprintColorAsync(formatkey));
};

export const imprintOptionTypeSelectedAsync =
  (formatkey, optionTypeSelected, logoLayoutSelected, textLayoutSelected) => (dispatch, getState) => {
    const state = getState();
    const currentStudioItemType = getStudioItemType(state);
    if (currentStudioItemType !== studioItemType.screenPrintedDigital)
      dispatch(setImprintOptionTypeSelectedAsync(formatkey, optionTypeSelected));
    const logoLayoutSetup = () => {
      if (logoLayoutSelected && logoLayoutSelected.key !== TYPESETTING_LOCATION_NA) {
        dispatch(logoLayoutSelectAsync(formatkey, logoLayoutSelected));
      } else {
        dispatch(defaultTypeSettingSelectedAsync(formatkey, typeSettingLocationType.Logo));
      }
    };

    const textLayoutSetup = () => {
      if (textLayoutSelected && textLayoutSelected.key !== TYPESETTING_LOCATION_NA) {
        dispatch(textLayoutSelectAsync(formatkey, textLayoutSelected));
      } else {
        dispatch(defaultTypeSettingSelectedAsync(formatkey, typeSettingLocationType.Text));
      }
    };

    switch (optionTypeSelected.key) {
      case imprintOptionType.TextOnly:
        textLayoutSetup();
        dispatch(clearUpTypeSettingSelectedAsync(formatkey, typeSettingLocationType.Logo));
        break;
      case imprintOptionType.LogoOnly:
        textLayoutSetup();
        dispatch(clearUpTypeSettingSelectedAsync(formatkey, typeSettingLocationType.Logo));
        break;
      case imprintOptionType.TextLogo:
        textLayoutSetup();
        logoLayoutSetup();
        break;
      case imprintOptionType.NoImprint:
      default:
        dispatch(clearUpTypeSettingSelectedAsync(formatkey, typeSettingLocationType.Text));
        dispatch(clearUpTypeSettingSelectedAsync(formatkey, typeSettingLocationType.Logo));
        break;
    }
  };

/**
 * for cart edit response
 * @param {*} operation
 * @param {*} optionTypeSelected
 * @param {*} logoLayoutSelected
 * @param {*} textLayoutSelected
 * @param {*} textDict
 */
export const imprintOptionAssembleAsync =
  ({ operation, imprintLocationsDict, logoLocationsDict, textDict, imageDict }) =>
  (dispatch, getState) => {
    try {
      dispatch(imprintOptionTypeInitAsync(Object.keys(operation)));
      Object.keys(operation).forEach((formatkey) => {
        const imprintLocationsSelected =
          imprintLocationsDict[formatkey] && imprintLocationsDict[formatkey].find((x) => x.selected);
        const logoLocationsSelected =
          logoLocationsDict[formatkey] && logoLocationsDict[formatkey].find((x) => x.selected);
        dispatch(
          imprintOptionTypeSelectedAsync(
            formatkey,
            { key: operation[formatkey] },
            logoLocationsSelected && {
              key: logoLocationsSelected.locationCode,
            },
            imprintLocationsSelected && {
              key: imprintLocationsSelected.locationCode,
            }
          )
        );

        let _recordTextColor = false;
        if (textDict && textDict[formatkey]) {
          const textlist = textDict[formatkey];
          if (textlist.length > 0 && textlist[0].color) {
            dispatch(recordTextColorAsync({ formatkey, color: textlist[0].color }));
            _recordTextColor = true;
          }
        }

        if (!_recordTextColor) {
          if (imageDict && imageDict[formatkey]) {
            const imagelist = imageDict[formatkey];
            if (imagelist.length > 0) {
              const outsideImage = imagelist.find(outsideUserImageMatch);
              if (outsideImage) {
                if (outsideImage.colors && outsideImage.colors.length > 0) {
                  const color = outsideImage.colors[0];
                  dispatch(recordTextColorAsync({ formatkey, color: color }));
                }
              }
            }
          }
        }
      });
    } catch (_) {}
  };

export const imprintAreasResetAsync = () => (dispatch, getState) => {
  const state = getState();
  const tempSelectedImprintAreaKeys = getTempSelectedImprintAreaKeys(state);
  const noImprintChosen = tempSelectedImprintAreaKeys
    .map((key) => getImprintOptionType(state, key) === imprintOptionType.NoImprint && key)
    .filter((x) => x);

  if (noImprintChosen.length > 0) {
    const effectChosen = tempSelectedImprintAreaKeys
      .map((key) => getImprintOptionType(state, key) !== imprintOptionType.NoImprint && key)
      .filter((x) => x);

    if (noImprintChosen.length === tempSelectedImprintAreaKeys.length) {
      dispatch(setImprintOptionTypeNoApplicableAsync(noImprintChosen));
      dispatch(imprintAreasCombinedInvalidAsync(effectChosen));
    } else {
      dispatch(imprintAreasCombinedEffectedAsync(effectChosen));
    }
  }
};

const imprintAreasCombinedEffectedAsync = (effectChosen) => (dispatch, getSate) => {
  const state = getSate();
  const imprintAreasCombinedDict = state.imprintAreasCombinedDict;
  const effectGroup = {};
  effectChosen.forEach((formatkey) => {
    Object.keys(imprintAreasCombinedDict).forEach((group) => {
      let allformatkeys = [];
      imprintAreasCombinedDict[group].combinations.forEach((com) => {
        allformatkeys = [...allformatkeys, ...com.formats].filter((x, index, _this) => _this.indexOf(x) === index);
      });
      if (allformatkeys.find((x) => x === formatkey)) {
        effectGroup[group] = effectGroup[group] || [];
        effectGroup[group].push(formatkey);
      }
    });
  });
  Object.keys(imprintAreasCombinedDict).forEach((groupKey) => {
    if (effectGroup[groupKey]) {
      dispatch(
        imprintAreasCombinedSelect({
          formatSelected: effectGroup[groupKey],
          groupKey,
        })
      );
    } else {
      dispatch(
        imprintAreasCombinedSelect({
          formatSelected: [],
          groupKey,
        })
      );
    }
  });
};

const imprintAreasCombinedInvalidAsync = () => (dispatch, getSate) => {
  const state = getSate();
  Object.keys(state.imprintAreasCombinedDict).forEach((group) => {
    dispatch(imprintAreasCombinedSelectAsync([], group));
  });
};

/**
 * setImprintOptionTypeNoApplicableAsync
 * @param {*} noImprintChosen
 */
export const setImprintOptionTypeNoApplicableAsync = (noImprintChosen) => (dispatch) => {
  noImprintChosen.forEach((formatkey) => {
    dispatch(
      setImprintOptionTypeSelectedAsync(formatkey, {
        key: imprintOptionType.NA,
      })
    );
  });
};

export const pmsColorValidation = (dispatch, color, showMessage) => {
  const message =
    color && color.colorType === colorType.Pms && color.colorId.length === 0
      ? PMS_COLOR_EXCEPTION_MESSAGE
      : color && color.colorType === colorType.Pms && color.colorId.length > 0 && color.colorReference.length === 0
      ? PMS_ENTRY_INVALID_MESSAGE
      : '';

  message &&
    showMessage &&
    dispatch(
      showMessageBox({
        show: true,
        message,
      })
    );

  return { valid: !message, message };
};

export const tooManyColorsExceptionCheck = (callback, colors) => (_, getState) => {
  const state = getState();
  const maxColorCount = getImprintOptionMaxColorCount(state);
  const colorWord = getSpecialSpellingWords(state).color.toLowerCase();

  const res =
    maxColorCount > 1
      ? (() => {
          const formatkey = getCurrentImprintAreaKey(state);
          const allSelectedImprintColors = getSelectedImprintColors(state, formatkey);
          const chosenColors = removeColorDuplicates(colors || []);
          const allTempColors = removeColorDuplicates([...allSelectedImprintColors, ...chosenColors]);
          const chosenCount = allTempColors.length - chosenColors.length;
          const exception = chosenCount > maxColorCount;
          return {
            exception,
            message: exception
              ? TOO_MANY_COLORS_CHOSEN_MESSAGE.replace('{maxColorCount}', maxColorCount)
                  .replace(/{colorword}/g, colorWord)
                  .replace('{colors}', maxColorCount > 1 ? 's' : '')
                  .replace('{chosenCount}', chosenCount)
              : 'ok',
          };
        })()
      : { exception: false, message: 'ok' };

  callback && callback(res);
};

export const removeColorDuplicates = (colors) => {
  let obj = {};
  const clrsRemoved = colors.reduce((cur, next) => {
    if (!obj[`${next.colorType}${next.colorId}`]) {
      obj[`${next.colorType}${next.colorId}`] = true;
      cur.push(next);
    }
    return cur;
  }, []);
  return clrsRemoved;
};

export const normalUserImageMatch = (userimage) => {
  return !(
    (userimage.type === userImageType.SavedArt && userimage.colorSpace === colorSpace.MultipleColor) || //MultipleColor SavedArt
    (userimage.type === userImageType.SharedArt && userimage.colorSpace === colorSpace.MultipleColor) || //MultipleColor SharedArt
    outsideUserImageMatch(userimage) || //OutsideSlogan,Sentiment,Verse
    (userimage.type === userImageType.StockArt && //StockArt
      userimage.colorType === stockArtColorType.Process &&
      userimage.colors &&
      userimage.colors.length > 1)
  );
};

export const getNormalImages = (images) => {
  const pickNormalImages = images && images.filter((x) => x.data && normalUserImageMatch(x.data));
  return pickNormalImages;
};

export const getHotStampedCheck = (processType) =>
  processType === ProcessTypes.HotStamped || processType === ProcessTypes.FoilFusing;

export const getDebossCheck = (processType) => processType === ProcessTypes.Deboss;

export const getIlluminatedLaserCheck = (processType) =>
  processType === ProcessTypes.IlluminatedLaser || processType === ProcessTypes.ColoredIlluminatedLaser;

export const checkShowImageColorized = ({ studioType, userImage, imprintArea = null }) =>
  !(
    (studioType !== studioItemType.digital &&
      (userImage.type === userImageType.Sentiment ||
        (userImage.type === userImageType.Slogan && imprintArea && getIlluminatedLaserCheck(imprintArea.processType)) ||
        (userImage.type === userImageType.SharedArt && userImage.colorSpace === colorSpace.MultipleColor))) ||
    (studioType === studioItemType.screenPrintedDigital && userImage.type === userImageType.UploadLogo)
  );

export const outsideUserImageMatch = (userImage) =>
  (userImage.type === userImageType.Slogan && userImage.isOutside) ||
  userImage.type === userImageType.Sentiment ||
  userImage.type === userImageType.Verse;

export const deleteImageAsync =
  ({ formatkey, guid }) =>
  (dispatch, getState) => {
    dispatch(setUserImageClone(null));
    dispatch(deleteImage({ canvasKey: formatkey, guid }));
    const state = getState();
    const imageDict = state.imageDict;
    const optionType = getImprintOptionType(state, formatkey);
    if (optionType === imprintOptionType.LogoOnly) {
      if (imageDict && imageDict[formatkey] && imageDict[formatkey].length > 0) {
        if (!imageDict[formatkey].find(outsideUserImageMatch)) {
          dispatch(recordTextColorAsync({ formatkey, color: null }));
        }
      } else {
        dispatch(recordTextColorAsync({ formatkey, color: null }));
      }
    }
  };

export const getColorDescription = (_color) =>
  _color.colorType === colorType.Pms ? `PMS: ${_color.colorId}` : _color.colorDescription;

export const recordImprintOptionAutoAsync = (formatkey) => (dispatch) => {
  dispatch(
    imprintOptionUISetAsync([formatkey], () => ({
      auto: true,
    }))
  );
};

export const recordUserImageSetupAsync = (formatkeys) => (dispatch) => {
  dispatch(
    imprintOptionUISetAsync(formatkeys, () => ({
      userImageSetup: true,
    }))
  );
};

export const mobileGuideModeSetupAsync = () => (dispatch, getState) => {
  const state = getState();
  const payload = {};
  Object.keys(state.imprintAreaDict).forEach((x) => (payload[x] = true));
  dispatch(setGuideMode(payload));
};

export const negativeMobileGuideModeAsync = () => (dispatch, getState) => {
  const state = getState();
  const formatkey = getCurrentImprintAreaKey(state);
  const payload = {};
  payload[formatkey] = false;
  dispatch(setGuideMode(payload));
};

export const getDefaultColor = (colors) => {
  let clr = {};
  if (colors && colors.length > 0) {
    const blk = colors.find(
      (x) =>
        x.colorType === colorType.Traditional &&
        (x.colorReference === '000000' ||
          x.colorId.toLowerCase() === 'blk' ||
          x.colorDescription.toLowerCase().indexOf('black') > -1)
    );
    clr = blk ? blk : colors[0];
  }
  return clr;
};
